import {assessYearTypes} from '../settingsTypes';

const initialState = {
    allAssessmentYears: [],
    loading: false,
    error: '',
    text: '',
    year:'',
    totalYearsCount: 0,
    allYears:[],
    erroryeardelete:false,
    loadingyeardelete:false,
    successyearupdate: false,
    loadingyearupdate: false,
    erroryearupdate:false,
    successyeardelete:false,
    erroryearcreate: '',
    successyearcreate: false,
}

export function yearReducer(state = initialState, action){
    switch (action.type){
        case assessYearTypes.CREATE_PAGE_REFRESH:
            return {
                ...state,
                allAssessmentYears: [],
                loading: false,
                error: '',
                text: '',
                year:'',
                totalYearsCount:0,
                allYears:[],
                erroryeardelete:false,
                loadingyeardelete:false,
                successyearupdate: false,
                loadingyearupdate: false,
                erroryearupdate:false,
                successyeardelete:false,
                erroryearcreate: '',
                successyearcreate: false,
            }
        //Year retrieve request sending
        case assessYearTypes.GET_ALL_ASSESSMENT_YEARS:
            return {
                ...state,
                loading: true,
                text: 'Get all the assessment years'
            }
        case assessYearTypes.GET_ALL_ASSESSMENT_YEARS_REQUEST:
            return {
                ...state,
                loading: true
            }
        case assessYearTypes.GET_ALL_ASSESSMENT_YEARS_SUCCESS:
            return {
                ...state,
                loading: false,
                allAssessmentYears: action.years.years,
                totalYearsCount: action.years.total_count
            }
        case assessYearTypes.GET_ALL_ASSESSMENT_YEARS_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            }
        //Year creation request sending
        case assessYearTypes.CREATE_YEAR_REQUEST:
            return {
                ...state,
                erroryearcreate: '',
                successyearcreate: false,
                loading: true
            }
        case assessYearTypes.CREATE_YEAR_SUCCESS:
            var temp = state.allYears;
            temp.push(action.years)
            return {
                ...state,
                allYears: temp,
                year: action.years.year_id,
                successyearcreate: true,
                loading: false
            }
        case assessYearTypes.CREATE_YEAR_FAILURE:
            return {
                ...state,
                erroryearcreate: action.error,
                loading: false
            }  
        //Year deletion request sending   
        case assessYearTypes.DELETE_YEAR_REQUEST:
            return {
            ...state,
            erroryeardelete: '',
            successyeardelete: false,
            loading: true,
            };
        case assessYearTypes.DELETE_YEAR_SUCCESS:
            return {
            ...state,
            successyeardelete: true,
            loading: false,
            };
        case assessYearTypes.DELETE_YEAR_FAILURE:
            return {
            ...state,
            erroryeardelete: action.error,
            loading: false,
            };
        //Year updation request sending
        case assessYearTypes.UPDATE_YEAR_REQUEST:
            return {
            ...state,
            erroryearupdate:'',
            successyearupdate: false,
            loading: true,
            };
        case assessYearTypes.UPDATE_YEAR_SUCCESS:
            return {
            ...state,
            successyearupdate: true,
            loading: false,
            };
        case assessYearTypes.UPDATE_YEAR_FAILURE:
            return {
            ...state,
            erroryearupdate: action.error,
            loading: false,
            };     
        default:
            return state
    }
}
